import React from "react";
import styled from "styled-components";

const Tag = styled.div`
  width: 34px;
  height: 18px;
  font-weight: 500;
  margin-left: auto;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ color }) => (color ? color : "var(--grey_1)")};
  background: ${({ background }) => (background ? background : "#D8DBFF")};
  border-radius: 8px;
`;

const NewTag = ({ text, color, background }) => {
  return (
    <Tag color={color} background={background}>
      {text}
    </Tag>
  );
};

export default NewTag;
